<!-- <ion-row class="ion-align-items-center mt-10">
  <ion-col size="12" size-md="auto"> -->
<div class="phi-flex-wrap-center  mt-10  mb-10 phi-gap-10">
  <!-- --------------------------- Year ------------------------------------------------------------ -->

  <mat-form-field class="w-100 mw-sm-150 mat-height40 mat-input-style">
    <mat-select placeholder="Select" [(ngModel)]="selectedYearForDWM" (selectionChange)="getYearSetupForDWM($event.value)">
      <mat-option [value]="item.year" *ngFor="let item of pmsYears">{{ sharedService.transformYearToFyFormat(item.year) }}</mat-option>
    </mat-select>
  </mat-form-field>
  <!-- --------------------------- Months ------------------------------------------------------------ -->

  <mat-form-field class="w-100 mat-height40 mw-sm-150 mat-input-style">
    <mat-select placeholder="Select Month" [(ngModel)]="selectedMonthForDWM" (selectionChange)="onMonthChangeDashboard()">
      <mat-option *ngFor="let month of filteredMonthsList" [value]="month">{{ month }}</mat-option>
    </mat-select>
  </mat-form-field>

    <!-- -------------------------------- Plant Location Multiselect ------------------------------- -->
          <ng-multiselect-dropdown *ngIf="loggedInUserRole === 'Super Admin' || loggedInUserRole === 'HR Admin'  " class="w-100 mw-sm-200 mat-height40 mat-input-style"  
           [data]="plantList" [(ngModel)]="selectedPlantsForDashbaordCounter" [settings]="plantDropdownSettings" placeholder="Select Plant Location" (onSelect)="onPlantSelectForCounter()" 
           (onDeSelect)="onPlantDeselectForCounter()" (onSelectAll)="onPlantSelectAllForCounter($event)" (onDeSelectAll)="onPlantDeSelectAllForCounter()"></ng-multiselect-dropdown>

  <!-- HR Admin Audit Trail -->
  <span class="ion-text-end ion-align-self-center audit-trail" *ngIf="loggedInUserRole=='HR Admin' || loggedInUserRole=='Super Admin'" (click)="onClickAuditTrail()">Audit Trail(Setup)</span>
  <!-- -------------------------------- Employee Dropdown for Manager ------------------------------- -->
  <!-- <ng-select *ngIf="(loggedInUserRole === 'Manager' || loggedInUserRole === 'HOD') && isTeamView" class="w-100 mw-sm-150 mat-height40 mat-input-style" [clearable]="false" placeholder="Select Employee" (change)="onEmployeeChange($event)" [(ngModel)]="selectedFilters.selectedEmpId" dropdownPosition="bottom"><ng-option [value]="item.id" *ngFor="let item of getIndirectEmployees">{{item.name}}</ng-option></ng-select> -->

  <!-- for hr and Admin -->
  <!-- <ng-select *ngIf="userIsAdminTypes?.userIsAdmin" class="w-100 mw-sm-150 mat-height40 mat-input-style" [clearable]="true" placeholder="Select Department" (change)="applyDataFilters($event, 'selectedDepartment')" [(ngModel)]="selectedFilters.selectedDepartment" dropdownPosition="bottom" [searchable]="true">
    <ng-option [value]="departments" *ngFor="let departments of departmentsList">{{departments}}</ng-option>
  </ng-select> -->

  <!-- multi select -->
  <ng-multiselect-dropdown *ngIf="userIsAdminTypes?.userIsAdmin" class="w-100 mw-sm-225 mat-height40 mat-input-style" [data]="departmentsList" [(ngModel)]="selectedFilters.selectedDepartment" [settings]="multiDropdownSettings" placeholder="Select Department" (onSelect)="applyDataFilters($event, 'selectedDepartment')" (onDeSelect)="applyDataFilters($event, 'selectedDepartment')" (onSelectAll)="applyDataFilters($event, 'selectedDepartment')" (onDeSelectAll)="applyDataFilters($event, 'selectedDepartment')"></ng-multiselect-dropdown>

  <ng-multiselect-dropdown *ngIf="userIsAdminTypes?.userIsAdmin" class="w-100 mw-sm-150 mat-height40 mat-input-style" [data]="gradesList" [(ngModel)]="selectedFilters.selectedGrade" [settings]="multiDropdownSettings" placeholder="Select Grade" (onSelect)="applyDataFilters($event, 'selectedGrade')" (onDeSelect)="applyDataFilters($event, 'selectedGrade')" (onSelectAll)="applyDataFilters($event, 'selectedGrade')" (onDeSelectAll)="applyDataFilters($event, 'selectedGrade')"></ng-multiselect-dropdown>
  <!-- multi select -->

  <!-- <ng-select *ngIf="userIsAdminTypes?.userIsAdmin" class="w-100 mw-sm-150 mat-height40 mat-input-style" [clearable]="true" placeholder="Select Grade" (change)="applyDataFilters($event, 'selectedGrade')" [(ngModel)]="selectedFilters.selectedGrade" dropdownPosition="bottom" [searchable]="true">
    <ng-option [value]="grades" *ngFor="let grades of gradesList">{{grades}}</ng-option>
  </ng-select> -->

  <ng-select *ngIf="userIsAdminTypes?.userIsAdmin" class="w-100 mw-sm-150 mat-height40 mat-input-style" [clearable]="true" placeholder="Select Employee" (change)="applyDataFilters($event, 'selectedEmpId')" [(ngModel)]="selectedFilters.selectedEmpId" dropdownPosition="bottom" [searchable]="true">
    <ng-option [value]="item?.id" *ngFor="let item of employeesList">{{ item?.firstName }} {{ item?.lastName }}</ng-option>
  </ng-select>
  <!-- End -->
  <!-- ---------------- Right side: Toggle ---------------- -->
  <span class="ion-text-end ion-align-self-center" *ngIf="!userIsAdminTypes?.userIsAdmin">
    <mat-slide-toggle *ngIf="loggedInUserRole === 'Manager' || loggedInUserRole === 'HOD'" [(ngModel)]="isTeamView" (change)="onTeamToggleChange($event.checked)" color="primary">{{ isTeamView ? 'Team' : 'Self' }}</mat-slide-toggle>
  </span>
</div>
<!-- </ion-col>
</ion-row> -->

<!-- <div class="phi-flex-wrap-center phi-gap-12">
  <ng-container *ngFor="let item of filteredDashboardCounters">
    <ion-row class="countercardBox h-100 cp text-left" [class.disabled-counter]="(loggedInUserRole === 'Employee' || !isTeamView) && (item.counterName === 'Count of Task Sent' || item.counterName === 'Avg Compliance Score' || item.counterName === 'Count of Task Approved' || item.counterName === 'Avg Compliance Score' || item.counterName === 'Done on Time' || item.counterName === 'Done with Delay' || item.counterName === 'Incomplete After Due Date' || item.counterName === 'Not Completed') " (click)="(loggedInUserRole === 'Employee' || !isTeamView) && (item.counterName === 'Count of Task Sent' || item.counterName === 'Count of Task Approved' || item.counterName === 'Avg Compliance Score' || item.counterName === 'Done on Time' || item.counterName === 'Done with Delay' || item.counterName === 'Incomplete After Due Date' || item.counterName === 'Not Completed') ? null : onClickCard(item.counterName) ">
      <ion-col size="12" size-md="auto" class="countercardBoxImg">
        <img class="counterIcon" src="{{item.counterIcon}}" [ngStyle]="{'background': item?.background ? item.background : 'red' }" />
      </ion-col>
      <ion-col size="12" size-md>
        <div class="font_semibold fs-14 fs_12ForMobile black_color countercardBoxName">{{item.counterName}}</div>
        <div class="font_bold mt-10 black_color countercardBoxCount" [ngStyle]="{'color': item?.color ? item.color : 'red' }">
          {{item.totalCount}}
          <span *ngIf="item.counterName === 'DWM Submitted' || item.counterName === 'DWM Approved'" class="fs-12 mt-5 ">{{ item.percentage }}%</span>
        </div>
      </ion-col>
    </ion-row>
  </ng-container>
</div> -->

<!-- <div class="phi-flex-wrap-center phi-gap-12"> -->
<!-- <ng-container *ngFor="let item of filteredDashboardCounters"> -->
<ion-row>
  <ion-col size="6" size-md="auto" *ngFor="let item of filteredDashboardCounters">
    <!-- <ion-row
      class="countercardBox h-100 cp text-left"
      [class.disabled-counter]=" ( loggedInUserRole === 'Employee' || ( !isTeamView && item.counterName !== 'Avg Compliance Score' ) ) && ( item.counterName === 'Count of Task Sent' || item.counterName === 'Count of Task Approved' || item.counterName === 'Avg Compliance Score' || item.counterName === 'Done on Time' || item.counterName === 'Done with Delay' || item.counterName === 'Incomplete After Due Date' || item.counterName === 'Not Completed' ) "
      (click)=" ( loggedInUserRole === 'Employee' || ( !isTeamView && item.counterName !== 'Avg Compliance Score' ) ) && ( item.counterName === 'Count of Task Sent' || item.counterName === 'Count of Task Approved' 
    || item.counterName === 'Avg Compliance Score' || item.counterName === 'Total Duration Worked(R&D)' || item.counterName === 'Done on Time' || item.counterName === 'Done with Delay' 
    || item.counterName === 'Incomplete After Due Date' || item.counterName === 'Not Completed' ) ? null : onClickCard(item.counterName)"> -->
    <ion-row class="countercardBox h-100 cp text-left" [ngClass]="{ 'disabled-counter': isCardDisabled(item) }" (click)="!isCardDisabled(item) && onClickCard(item.counterName)">
      <ion-col size="12" size-sm="auto" class="countercardBoxImg mx-sm-center">
        <img class="counterIcon" [src]="item.counterIcon" [ngStyle]="{ background: item?.background ? item.background : 'red' }" />
      </ion-col>

      <ion-col size="12" size-sm>
        <div class="font_semibold fs-14 fs_12ForMobile black_color countercardBoxName mx-sm-center">{{ item.counterName }}</div>
        <div class="font_bold mt-10 black_color countercardBoxCount mx-sm-center" [ngStyle]="{ color: item?.color ? item.color : 'red' }">
          {{ item.totalCount }}
          <span *ngIf=" item.counterName === 'DWM Submitted' || item.counterName === 'DWM Approved' " class="fs-12 mt-5">{{ item.percentage }}%</span>
        </div>
      </ion-col>
    </ion-row>
  </ion-col>
</ion-row>
<!-- </ng-container> -->
<!-- </div> -->

<!-- ------------------------------ DWM Dashboard Graphs --------------------------------------- -->

<!-- ---------------------------- Plant Location Wise Task Status ------------------------------ -->
<ion-row class="mt-10" *ngIf="(loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Super Admin' ) ">
  <ion-col size="12" size-lg="12">
    <div class="table-card-box dashboard-card-400 mb-15" *ngIf="loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Super Admin'">
      <ion-row class="ion-align-items-center">
        <ion-col size="auto">
          <h4>Plant Location Wise Task Status</h4>
        </ion-col>
        <ion-col size>
          <div class="phi-flex-wrap-center phi-gap-12 ion-justify-content-end">
            <img [src]="'assets/icon/activeBarChart.svg'" class="cp" />
            <img *ngIf="mobileResponsiveService.getIfWebLogin" src="assets/svg/pdf.svg" class="file-icon" (click)="downloadPlantLocationTaskStatusGraphPDF()" />
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="auto">
          <div class="center-content justify-content-flex-end gap-5">
            <!-- Year -->
            <mat-form-field class="w-100 mw-sm-150 mat-height40 mat-input-style">
              <mat-select placeholder="Select" [(ngModel)]="selectedGraphYearForPlantLocation" (selectionChange)="onPlantGraphYearChange($event.value)">
                <mat-option [value]="item.year" *ngFor="let item of pmsYears">{{ sharedService.transformYearToFyFormat(item.year) }}</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Month -->
            <mat-form-field class="w-100 mw-sm-150 mat-height40 mat-input-style">
              <mat-select placeholder="Select Month" [(ngModel)]="selectedGraphMonthForPlantLocation" (selectionChange)="onPlantGraphMonthChange($event.value)">
                <mat-option *ngFor="let month of filteredMonthsList" [value]="month">{{ month }}</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Plant Location -->
          <!-- -------------------------------- Plant Multiselect ------------------------------- -->
          <ng-multiselect-dropdown *ngIf="loggedInUserRole === 'Super Admin' || loggedInUserRole === 'HR Admin' " class="w-100 mw-sm-200 mat-height40 mat-input-style"
           [data]="plantList" [(ngModel)]="selectedPlants" [settings]="plantDropdownSettings" placeholder="Select Plant Location" (onSelect)="onPlantSelect()" 
           (onDeSelect)="onPlantDeselect()" (onSelectAll)="onPlantSelectAll($event)" (onDeSelectAll)="onPlantDeSelectAll()"></ng-multiselect-dropdown>


          </div>
        </ion-col>
      </ion-row>
      <!-- Chart -->
      <div class="table-container">
        <div id="plantTaskStatus" style="height: 400px;"></div>
      </div>
    </div>
  </ion-col>


</ion-row>


<!-- ---------------------------- My Task Status ------------------------------ -->
<ion-row class="mt-10" *ngIf="(loggedInUserRole === 'Employee' || loggedInUserRole === 'Manager' || loggedInUserRole === 'HOD') ">
  <ion-col size="12" size-lg="6">
    <div class="table-card-box dashboard-card-400 mb-15" *ngIf="loggedInUserRole === 'Employee' || loggedInUserRole === 'Manager' || loggedInUserRole === 'HOD'">
      <ion-row class="ion-align-items-center">
        <ion-col size="auto">
          <h4>{{ isTeamView ? 'Team Task Status' : 'My Task Status' }}</h4>
        </ion-col>
        <ion-col size>
          <div class="phi-flex-wrap-center phi-gap-12 ion-justify-content-end">
            <img [src]="isTeamView ? 'assets/icon/activeBarChart.svg' : 'assets/icon/PieIconActive.svg'" class="cp" />
            <img *ngIf="mobileResponsiveService.getIfWebLogin" src="assets/svg/pdf.svg" class="file-icon" (click)="downloadTaskStatusGraphPDF()" />
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="auto">
          <div class="center-content justify-content-flex-end gap-5">
            <!-- Year -->
            <mat-form-field class="w-100 mw-sm-150 mat-height40 mat-input-style">
              <mat-select placeholder="Select" [(ngModel)]="selectedGraphYear" (selectionChange)="onGraphYearChange($event.value)">
                <mat-option [value]="item.year" *ngFor="let item of pmsYears">{{ sharedService.transformYearToFyFormat(item.year) }}</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Month -->
            <mat-form-field class="w-100 mw-sm-150 mat-height40 mat-input-style">
              <mat-select placeholder="Select Month" [(ngModel)]="selectedGraphMonth" (selectionChange)="onMonthChangeGraph($event.value)">
                <mat-option *ngFor="let month of filteredMonthsList" [value]="month">{{ month }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ion-col>
      </ion-row>

      <!-- Chart -->
      <div class="table-container">
        <div id="empTaskStatus" style="height: 400px;"></div>
      </div>
    </div>
  </ion-col>

  <!-- ----------------------- My Compliance Score Trend  ---------------------------- -->
  <ion-col size="12" size-lg="6">
    <div class="table-card-box dashboard-card-400 mb-15">
      <ion-row class="ion-align-items-center">
        <ion-col size="auto">
          <h4>{{ isTeamView ? 'Team Compliance Score Trend' : 'My Compliance Score Trend' }}</h4>
        </ion-col>
        <ion-col size>
          <div class="phi-flex-wrap-center phi-gap-12 ion-justify-content-end">
            <img src="assets/icon/activeLineChart.svg" class="cp" />
            <img *ngIf="mobileResponsiveService.getIfWebLogin" src="assets/svg/pdf.svg" class="file-icon" (click)="downloadDashboardGraphForCompliancePDF()" />
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="auto">
          <div class="center-content justify-content-flex-end gap-5">
            <!-- Year -->
            <mat-form-field class="w-100 mw-sm-150 mat-height40 mat-input-style">
              <mat-select placeholder="Select" [(ngModel)]="selectedGraphYearForCompliance" (selectionChange)="onComplianceYearChange($event.value)">
                <mat-option [value]="item.year" *ngFor="let item of pmsYears">{{ sharedService.transformYearToFyFormat(item.year) }}</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Month -->
            <mat-form-field class="w-100 mw-sm-150 mat-height40 mat-input-style">
              <mat-select placeholder="Select Month" [(ngModel)]="selectedGraphMonthForCompliance" (selectionChange)="onComplianceMonthChange($event.value)">
                <mat-option *ngFor="let month of filteredMonthsList" [value]="month">{{ month }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ion-col>
      </ion-row>

      <!-- Chart -->
      <div class="table-container">
        <div id="complianceScore" style="height: 400px;"></div>
      </div>
    </div>
  </ion-col>

  <!-- ---------------------------------------------------- Critical Task ------------------------------------- -->
  <ion-col size="12" size-lg="6" *ngIf="!isTeamView">
    <div class="table-card-box mb-15 dashboard-card-400">
      <ion-row class="ion-align-items-center">
        <ion-col size="auto">
          <h4>Critical Tasks</h4>
        </ion-col>
        <ion-col size>
          <div class="phi-flex-wrap-center phi-gap-12 ion-justify-content-end">
            <img src="assets/icon/TableIconActive.svg" class="cp" />
            <img *ngIf="mobileResponsiveService.getIfWebLogin" src="assets/svg/pdf.svg" class="file-icon" (click)="downloadCriticalTaskPDF()" />
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="auto">
          <div class="center-content justify-content-flex-end gap-5">
            <!-- Year -->
            <mat-form-field class="w-100 mw-sm-150 mat-height40 mat-input-style">
              <mat-select placeholder="Select" [(ngModel)]="selectedGraphYearForCritical" (selectionChange)="onCriticalTaskYearChange($event.value)">
                <mat-option [value]="item.year" *ngFor="let item of pmsYears">{{ sharedService.transformYearToFyFormat(item.year) }}</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Month -->
            <mat-form-field class="w-100 mw-sm-150 mat-height40 mat-input-style">
              <mat-select placeholder="Select Month" [(ngModel)]="selectedGraphMonthForCritical" (selectionChange)="onCriticalTaskMonthChange($event.value)">
                <mat-option *ngFor="let month of filteredMonthsList" [value]="month">{{ month }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ion-col>
      </ion-row>

      <ng-container *ngIf="  criticalTaskList?.length; else noCriticalTask">
        <div id="criticalTasksTable" class="table-container mb-15">
          <table class="hover mb-15 w-100">
            <thead>
              <tr>
                <th class="text-center">Critical</th>
                <th>Task Name</th>
                <th>Category</th>
                <th>Due Date</th>
                <th>Status</th>
                <th>Manager Comment</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let task of criticalTaskList">
                <!-- Star Indicator -->
                <td>
                  <svg viewBox="0 0 24 24" class="star" *ngIf="task.criticalTask">
                    <polygon points="12 2 15 9 22 9 17 14 19 21 12 17 5 21 7 14 2 9 9 9" />
                  </svg>
                </td>

                <!-- Task Name (Actionable) -->
                <td>{{ task.taskName }}</td>

                <!-- Category -->
                <td>{{ task.categoryName }}</td>

                <!-- Due Date -->
                <td>{{ task.dueDate | date: 'dd MMM yyyy' }}</td>

                <!-- Status -->
                <td>
                  <span>{{ formatedataVariable(task.status) }}</span>
                </td>

                <!-- Manager Comment -->
                <td>
                  <span *ngIf="task.managerComment; else noComment">{{ task.managerComment }}</span>
                  <ng-template #noComment>
                    <span class="text-muted">—</span>
                  </ng-template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>

      <!-- No Data -->
      <ng-template #noCriticalTask>
        <div class="phi-flex-wrap-center phi-align-items-center h-100 no-data-msg-box">
          <div class="no-data-msg">No data available</div>
        </div>
      </ng-template>
    </div>
  </ion-col>

  <!-- --------------------------- Incomplete Task ------------- -->
  <ion-col size="12" size-lg="6">
    <div class="table-card-box mb-15 dashboard-card-400">
      <ion-row class="ion-align-items-center">
        <ion-col size="auto">
          <h4>{{ isTeamView ? 'Incomplete Tasks from Previous Periods ' : 'Incomplete Tasks' }}</h4>
        </ion-col>
        <ion-col size>
          <div class="phi-flex-wrap-center phi-gap-12 ion-justify-content-end">
            <img src="assets/icon/TableIconActive.svg" class="cp" />
            <img *ngIf="mobileResponsiveService.getIfWebLogin" src="assets/svg/pdf.svg" class="file-icon" (click)="downloadIncompleteTasksPDF()" />
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="auto">
          <div class="center-content justify-content-flex-end gap-5">
            <!-- Year -->
            <mat-form-field class="w-100 mw-sm-150 mat-height40 mat-input-style">
              <mat-select placeholder="Select" [(ngModel)]="selectedGraphYearForIncomplete" (selectionChange)="onIncompleteTaskYearChange($event.value)">
                <mat-option [value]="item.year" *ngFor="let item of pmsYears">{{ sharedService.transformYearToFyFormat(item.year) }}</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Month -->
            <mat-form-field class="w-100 mw-sm-150 mat-height40 mat-input-style">
              <mat-select placeholder="Select Month" [(ngModel)]="selectedGraphMonthForIncomplete" (selectionChange)="onIncompleteTaskMonthChange($event.value)">
                <mat-option *ngFor="let month of filteredMonthsList" [value]="month">{{ month }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ion-col>
      </ion-row>

      <ng-container *ngIf="incompleteTaskList.length; else noData">
        <div class="table-container mb-15" id="incompleteTasksTable">
          <table class="hover mb-15 w-100">
            <thead>
              <tr>
                <th>Task Name</th>
                <th>Category</th>
                <th>Original Due Date</th>
                <th>Days Overdue</th>
                <th>Manager Comment</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let task of incompleteTaskList">
                <td class="actionable-text">{{ task.taskName }}</td>
                <td>{{ task.categoryName }}</td>
                <td>{{ task.originalDueDate | date: 'dd MMM yyyy' }}</td>
                <td class="text-danger fw-600 text-center">{{ task.daysOverdue }}</td>
                <td>{{ task.managerComment || '—' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>

      <ng-template #noData>
        <div class="phi-flex-wrap-center phi-align-items-center h-100 no-data-msg-box">
          <div class="no-data-msg">No data available</div>
        </div>
      </ng-template>
    </div>
  </ion-col>

  <!-- ---------- Product allocation for R&D User ------------------- -->
  <ion-col size="12" size-lg="6">
    <div class="table-card-box mb-15 dashboard-card-400" *ngIf="showRndGraph">
      <ion-row class="ion-align-items-center">
        <ion-col size="auto">
          <h4>Product Allocation</h4>
        </ion-col>
        <ion-col size>
          <div class="phi-flex-wrap-center phi-gap-12 ion-justify-content-end">
            <img src="assets/icon/activeBarChart.svg" class="cp" />
            <img *ngIf="mobileResponsiveService.getIfWebLogin" src="assets/svg/pdf.svg" class="file-icon" (click)="downloadProductAllocationPDF()" />
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="auto">
          <div class="center-content justify-content-flex-end gap-5">
            <!-- Year -->
            <mat-form-field class="w-100 mw-sm-150 mat-height40 mat-input-style">
              <mat-select placeholder="Select" [(ngModel)]="selectedGraphYearForProduct" (selectionChange)="onProductAllocationYearChange($event.value)">
                <mat-option [value]="item.year" *ngFor="let item of pmsYears">{{ sharedService.transformYearToFyFormat(item.year) }}</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Month -->
            <mat-form-field class="w-100 mw-sm-150 mat-height40 mat-input-style">
              <mat-select placeholder="Select Month" [(ngModel)]="selectedGraphMonthForProduct" (selectionChange)="onProductAllocationMonthChange($event.value)">
                <mat-option *ngFor="let month of filteredMonthsList" [value]="month">{{ month }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ion-col>
      </ion-row>

      <!-- Chart -->
      <div class="table-container">
        <div id="productAllocation" style="height: 400px;"></div>
      </div>
    </div>
  </ion-col>
</ion-row>
